import React from 'react';
import { useSidebarStore } from '../../stores/useSidebarStore';
import { 
  TodoPage, 
  UrgentPage, 
  FavoritesPage,
  QuoteCreatePage,
  QuoteHistoryPage,
  OrderManagePage,
  JamakePage,
  ProjectCreatePage,
  ProjectPage,
  WorkManagePage,
  WorkFavoritesPage,
  EmptyPage 
} from '../../pages';
import { TaskTypeManagementPage } from '../../pages/TaskTypeManagementPage';
import { WorkPresetManagementPage } from '../../pages/WorkPresetManagementPage';
import WorkerManagementPage from '../../pages/WorkerManagementPage';
import WorkerGroupManagementPage from '../../pages/WorkerGroupManagementPage';

const Dashboard: React.FC = () => {
  const { activeMenu, menuItems } = useSidebarStore();

  // Find current menu item
  const currentMenuItem = menuItems.find(item => 
    item.id === activeMenu || 
    item.children?.some(child => child.id === activeMenu)
  );

  const currentSubMenuItem = currentMenuItem?.children?.find(child => child.id === activeMenu);
  const displayItem = currentSubMenuItem || currentMenuItem;

  // Page routing logic
  const renderPage = () => {
    switch (activeMenu) {
      // Dashboard pages
      case 'todo':
        return <TodoPage />;
      case 'urgent':
        return <UrgentPage />;
      case 'favorites':
        return <FavoritesPage />;
      
      // Quote pages
      case 'quote-create':
        return <QuoteCreatePage />;
      case 'quote-history':
        return <QuoteHistoryPage />;
      
      // Order pages
      case 'order-manage':
        return <OrderManagePage />;
      case 'order-jamake':
        return <JamakePage />;
      
      // Work pages
      case 'project-create':
        return <ProjectCreatePage />;
      case 'project':
        return <ProjectPage />;
      case 'work-manage':
        return <WorkManagePage />;
      case 'work-favorites':
        return <WorkFavoritesPage />;
      case 'task-types':
        return <TaskTypeManagementPage />;
      case 'work-presets':
        return <WorkPresetManagementPage />;
    case 'workers':
      return <WorkerManagementPage />;
    case 'worker-groups':
      return <WorkerGroupManagementPage />;
      
      // Default pages for main menu items
      case 'dashboard':
        return (
          <EmptyPage
            title="대시보드"
            icon="BarChart3"
            description="전체 현황과 주요 지표를 확인할 수 있습니다."
          />
        );
      case 'quote':
        return (
          <EmptyPage
            title="견적"
            icon="FileText"
            description="번역/통역 견적 관리 시스템입니다."
          />
        );
      case 'order':
        return (
          <EmptyPage
            title="주문"
            icon="ShoppingCart"
            description="주문 관리 시스템입니다."
          />
        );
      case 'work':
        return (
          <EmptyPage
            title="작업"
            icon="FolderOpen"
            description="번역 작업 관리 시스템입니다."
          />
        );
      case 'memory':
        return (
          <EmptyPage
            title="메모리"
            icon="Database"
            description="번역 메모리와 용어 관리 시스템입니다."
          />
        );
      case 'workers':
        return (
          <EmptyPage
            title="작업자"
            icon="Users"
            description="번역사 및 작업자 관리 시스템입니다."
          />
        );
      case 'settlement':
        return (
          <EmptyPage
            title="정산"
            icon="Calculator"
            description="매출 및 작업자 정산 시스템입니다."
          />
        );
      case 'clients':
        return (
          <EmptyPage
            title="고객사"
            icon="Building"
            description="고객사 관리 시스템입니다."
          />
        );
      case 'automation':
        return (
          <EmptyPage
            title="자동화"
            icon="Zap"
            description="워크플로 자동화 시스템입니다."
          />
        );
      
      default:
        return (
          <EmptyPage
            title={displayItem?.label || "페이지를 찾을 수 없음"}
            icon={displayItem?.icon || "AlertTriangle"}
            description="요청하신 페이지를 찾을 수 없습니다."
          />
        );
    }
  };

  return (
    <div className="flex-1 flex flex-col">
      {renderPage()}
    </div>
  );
};

export default Dashboard;
